import Card from './components/Card';

export default function App() {
  return (
    <main className="flex h-screen items-center justify-center bg-brand-bg font-montserrat">
      <Card />
    </main>
  );
}
